import React, { Component } from "react";

import PropTypes from "prop-types";

import { connect } from "react-redux";

import ReactHighcharts from "react-highcharts";
import moment from "moment";

import { dashbaordFrequencies, dateFormats } from "../../utility/enums";
const mapStateToProps = (state) => ({
  graphInfo: state.dashboardInfo.graphInfo,
});

class Graph extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let goodEmailsData = [],
      badEmailsData = [],
      unknownEmailsData = [],
      tickFrequency = 1,
      pointStart = 0;

    const graphInfo = this.props.graphInfo;
    let pointInterval = graphInfo.frequency == dashbaordFrequencies.TODAY ? 1000 * 3600 : 1000 * 3600 * 24;
    let noofPts = 0;

    // console.log(" this graph info " + JSON.stringify(graphInfo));

    if (graphInfo.frequency == dashbaordFrequencies.WEEK) tickFrequency = 1;
    else if (graphInfo.frequency == dashbaordFrequencies.MONTH) tickFrequency = 2;
    else if (graphInfo.frequency == dashbaordFrequencies.THREEMONTHS) tickFrequency = 7;
    else if (graphInfo.frequency == dashbaordFrequencies.TODAY) tickFrequency = 1 / 24;
    else tickFrequency = 1;

    if (graphInfo.frequency == dashbaordFrequencies.TODAY) {
      let startTime = moment(graphInfo.fromDate);
      let endTime = moment(graphInfo.toDate);

      const duration = moment.duration(endTime.diff(startTime));
      noofPts = parseInt(duration.asHours());

      pointStart = moment().startOf("day").add(moment().utcOffset(), "minutes").unix() * 1000;

      for (let idx = 0; idx <= noofPts; idx++) {
        const currentTime = new moment(moment().startOf("day"), dateFormats.DATE_HOUR)
          .add(idx, "hours")
          .format(dateFormats.DATE_HOUR);

        // console.log("currentTime==  " + currentTime);
        const currentItem = graphInfo.graphData.Items.find((x) => x.verifiedDate == currentTime);

        // console.log("matched currentItem = " + JSON.stringify(currentItem));
        if (currentItem != undefined) {
          goodEmailsData.push(currentItem.good);
          badEmailsData.push(currentItem.bad);
          unknownEmailsData.push(currentItem.unknown);
        } else {
          goodEmailsData.push(0);
          badEmailsData.push(0);
          unknownEmailsData.push(0);
        }
      }
    } else {
      pointStart = new moment.utc(graphInfo.fromDate).add(moment().utcOffset(), "minutes").startOf("day").unix() * 1000;

      // console.log(pointStart);
      noofPts = new moment(graphInfo.toDate).diff(new moment(graphInfo.fromDate).utc(), "days") + 1;

      for (let idx = 0; idx < noofPts; idx++) {
        const currentDay = new moment(graphInfo.fromDate)
          .add(moment().utcOffset(), "minutes")
          .add(idx, "days")
          .format(dateFormats.DATE_FORMAT);

        // console.log("currentDay==  " + currentDay);
        const currentItem = graphInfo.graphData.Items.find((x) => x.verifiedDate == currentDay);

        // console.log("matched currentItem = " + JSON.stringify(currentItem));
        if (currentItem != undefined) {
          goodEmailsData.push(currentItem.good);
          badEmailsData.push(currentItem.bad);
          unknownEmailsData.push(currentItem.unknown);
        } else {
          goodEmailsData.push(0);
          badEmailsData.push(0);
          unknownEmailsData.push(0);
        }
      }
    }

    const series = [
      {
        name: "Valid",
        data: goodEmailsData,
        color: "#1ABB9C",
        pointInterval: pointInterval,
        pointStart: pointStart,
      },
      {
        name: "Invalid ",
        data: badEmailsData,
        color: "#E74C3C",
        pointInterval: pointInterval,
        pointStart: pointStart,
      },
      {
        name: "Unknown ",
        data: unknownEmailsData,
        color: "#34495E",
        pointInterval: pointInterval,
        pointStart: pointStart,
      },
    ];

    const config = {
      chart: { type: "line" },
      title: { text: "", x: -20 },
      credits: { enabled: false },
      areaspline: { fillOpacity: 0.4 },
      xAxis: {
        minTickInterval: pointInterval * tickFrequency,
        type: "datetime",
        tickmarkPlacement: "on",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        gridLineWidth: 1,
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        labels: {
          y: 10,
          rotation: -30,
          align: "right",
          format: graphInfo.frequency != dashbaordFrequencies.TODAY ? "{value:%e-%b}" : "{value:%H:00}",
        },
      },
      yAxis: {
        title: { text: "No. of Verifications" },
        plotLines: [{ value: 0, width: 1, color: "#808080" }],
        min: 0,
      },
      series: series,
    };

    return <ReactHighcharts config={config} />;
  }
}

export default connect(mapStateToProps)(Graph);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Graph.js